/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserUpdateEmergencyConfigRequest
 */
export interface OrgUserUpdateEmergencyConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateEmergencyConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateEmergencyConfigRequest
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdateEmergencyConfigRequest
     */
    new_emergency_config_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserUpdateEmergencyConfigRequest
     */
    should_force_apply: boolean;
}

/**
 * Check if a given object implements the OrgUserUpdateEmergencyConfigRequest interface.
 */
export function instanceOfOrgUserUpdateEmergencyConfigRequest(value: object): value is OrgUserUpdateEmergencyConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('new_emergency_config_id' in value) || value['new_emergency_config_id'] === undefined) return false;
    if (!('should_force_apply' in value) || value['should_force_apply'] === undefined) return false;
    return true;
}

export function OrgUserUpdateEmergencyConfigRequestFromJSON(json: any): OrgUserUpdateEmergencyConfigRequest {
    return OrgUserUpdateEmergencyConfigRequestFromJSONTyped(json, false);
}

export function OrgUserUpdateEmergencyConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserUpdateEmergencyConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'new_emergency_config_id': json['new_emergency_config_id'],
        'should_force_apply': json['should_force_apply'],
    };
}

export function OrgUserUpdateEmergencyConfigRequestToJSON(json: any): OrgUserUpdateEmergencyConfigRequest {
    return OrgUserUpdateEmergencyConfigRequestToJSONTyped(json, false);
}

export function OrgUserUpdateEmergencyConfigRequestToJSONTyped(value?: OrgUserUpdateEmergencyConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'new_emergency_config_id': value['new_emergency_config_id'],
        'should_force_apply': value['should_force_apply'],
    };
}

